// SocialLinks — the social row for the landing footer. The shared SOCIAL_MARKS
// (lib/brand/socialMarks) hold the LOGO only; here the soft rounded field
// (.wl-social) IS the shared container, so every mark reads as one system:
// same rounded square, same proportions, its own logo fitted inside. Nothing
// draws a second box of its own.
//
// The viewBox is cropped to the container region (SOCIAL_FRAME) so the field
// edge and the mark's notional container coincide; the stroke is divided back
// out by that scale so it lands at the same weight as the rest of the chrome.
//
// A "#" href is a placeholder and never renders, so we don't ship dead marks.

import type { CSSProperties } from "react";
import { SOCIAL_MARKS, SOCIAL_FRAME as F } from "../lib/brand/socialMarks";

const SIZE = 30; // the container region, drawn inside the 38px field
const STROKE = 1.35 / (SIZE / F.size); // keep ~1.35px on screen at any scale

export default function SocialLinks({ className, style }: { className?: string; style?: CSSProperties }) {
  const live = SOCIAL_MARKS.filter((s) => s.href && s.href !== "#");
  if (live.length === 0) return null;
  return (
    <div className={["wl-socials", className].filter(Boolean).join(" ")} style={style}>
      {live.map((s) => (
        <a key={s.name} href={s.href} target="_blank" rel="noopener noreferrer" className="wl-social" aria-label={s.label}>
          <svg
            viewBox={`${F.x} ${F.y} ${F.size} ${F.size}`}
            width={SIZE}
            height={SIZE}
            fill="none"
            stroke="currentColor"
            strokeWidth={STROKE}
            strokeLinecap="round"
            strokeLinejoin="round"
            aria-hidden="true"
            dangerouslySetInnerHTML={{ __html: s.inner }}
          />
        </a>
      ))}
    </div>
  );
}
